import { Component } from '@angular/core';
import { SelectTemplate } from 'src/app/@amiga-pyme/select/templates/select.template';
import {
  IPointOfSale,
  POINT_OF_SALE_TTL_ES
} from '../../point-of-sale-free.interface';
import { PointOfSaleFreeService } from '../../point-of-sale-free.service';

@Component({
  selector: 'pg-point-of-sale-free-select',
  template: `
    <ami-select
      [settings]="table.settings"
      [data]="table.data"
      (selectedRowsEvent)="onReciveSelectedRows($event)"
    ></ami-select>
  `
})
export class PointOfSaleFreeSelectComponent extends SelectTemplate {
  constructor(private serviceBase: PointOfSaleFreeService) {
    super(POINT_OF_SALE_TTL_ES, serviceBase);
  }

  ngOnInit() {
    this.table.settings = {
      title: POINT_OF_SALE_TTL_ES,
      columns: [
        { header: 'Sucursal', field: 'branchStoreName' },
        { header: 'Código', field: 'code' },
        { header: 'Serie de Comprobante', field: 'seriesOfReceipts' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IPointOfSale[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
